<template>
    <div class="flex flex-row items-center justify-center">
        <form @submit.prevent="sendMessage" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
            <div class="mb-4">
                <label class="block text-grey-darker text-sm font-bold mb-2" for="username">
                    E-mailadres
                </label>
                <input class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                       id="email" type="email" placeholder="E-mailadres" v-model="email" required>
            </div>
            <div class="mb-4">
                <label class="block text-grey-darker text-sm font-bold mb-2" for="username">
                    Onderwerp
                    <small>(optioneel)</small>
                </label>
                <input class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline"
                       id="message" type="text" placeholder="Onderwerp" v-model="subject">
            </div>
            <div class="mb-4">
                <label class="block text-grey-darker text-sm font-bold mb-2" for="username">
                    Bericht
                </label>
                <div class="md:flex-1 mt-2 mb:mt-0 md:px-3">
                        <textarea placeholder="Typ hier je bericht (max. 200 karakters)"
                                  v-on:input="countCharacters($event.target.value)"
                                  rows="8"
                                  cols="50"
                                  v-model="message"
                                  maxlength="200"
                                  class="resize-none shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline">
                        </textarea>
                    <p v-if="textActualLength < 200 && textLength > 0"
                       class="text-grey-dark mt-2">
                        Nog {{textLength}} karakter(s) over
                    </p>
                    <p v-if="textLength === 0 && textActualLength === 200"
                       class="text-grey-dark mt-2">
                        Je hebt het maximum aantal karakters bereikt.
                        <br>
                        <br>
                        Heb je toch een langer bericht? Dan kun je beter bellen!
                        <br>
                        Dat is ook een stuk sneller!

                    </p>
                </div>
            </div>
            <div class="flex items-center justify-center">
                <button type="submit"
                        class="button hover:bg-blue-dark text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                    Verstuur
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import api from 'axios'
    import Swal from "sweetalert2"

    export default {
        name: "Message",
        data() {
            return {
                textLength: 0,
                textActualLength: 0,
                message: '',
                email: '',
                subject: ''
            }
        },
        methods: {
            countCharacters(str) {
                this.textLength = 200 - parseInt(str.length)
                this.textActualLength = str.length
            },
            sendMessage() {
                let data = {
                    email: this.email,
                    subject: this.subject,
                    message: this.message
                };

                api.post('/mail', data)
                    .then(res => {
                        console.log(res);
                        Swal.fire({
                            type: "success",
                            title: "Je bericht is verstuurd!",
                            showConfirmButton: false,
                            timer: 1500
                        })
                    })
                    .catch(err => {
                        Swal.fire({
                            type: "error",
                            title: "Hm...",
                            text: `Het lijkt erop dat je bericht niet opgestuurd kon worden, probeer het later opnieuw of
                            bel ons even op`,
                        })
                    });
            }
        }
    }
</script>

<style scoped>
    .button {
        background: #00aeef;
        transition: 200ms;
    }

    .button:hover {
        background: #0086ba;
        transition: 200ms;
    }
</style>
